 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"page-carte-e-servizi":"page-carte-e-servizi","page-carte-e-servizi-carte":"page-carte-e-servizi-carte","page-carte-e-servizi-carte-creditclassic":"page-carte-e-servizi-carte-creditclassic","page-carte-e-servizi-carte-creditprestige":"page-carte-e-servizi-carte-creditprestige","page-carte-e-servizi-carte-internazionale":"page-carte-e-servizi-carte-internazionale","page-carte-e-servizi-carte-panoramica":"page-carte-e-servizi-carte-panoramica","page-carte-e-servizi-carte-prepagata":"page-carte-e-servizi-carte-prepagata","page-carte-e-servizi-internetBanking":"page-carte-e-servizi-internetBanking","page-carte-e-servizi-tecnologia":"page-carte-e-servizi-tecnologia","page-carte-e-servizi-tecnologia-applePay":"page-carte-e-servizi-tecnologia-applePay","page-carte-e-servizi-tecnologia-bancomatPay":"page-carte-e-servizi-tecnologia-bancomatPay","page-carte-e-servizi-tecnologia-bancomatPay-dettagli":"page-carte-e-servizi-tecnologia-bancomatPay-dettagli","page-carte-e-servizi-tecnologia-digitalPayments":"page-carte-e-servizi-tecnologia-digitalPayments","page-carte-e-servizi-tecnologia-mobilePayments":"page-carte-e-servizi-tecnologia-mobilePayments","page-carte-e-servizi-tecnologia-plick":"page-carte-e-servizi-tecnologia-plick","page-footer":"page-footer","page-footer-numeriUtili":"page-footer-numeriUtili","page-footer-privacy":"page-footer-privacy","page-footer-sicurezza":"page-footer-sicurezza","page-footer-trasparenza":"page-footer-trasparenza","page-help":"page-help","page-index":"page-index","page-insiemeperlambiente":"page-insiemeperlambiente","page-insiemeperlambiente-ilnostroimpegno":"page-insiemeperlambiente-ilnostroimpegno","page-insiemeperlambiente-mediterraneo":"page-insiemeperlambiente-mediterraneo","page-insiemeperlambiente-plasticFreeVideo":"page-insiemeperlambiente-plasticFreeVideo","page-partner":"page-partner","page-quanto":"page-quanto","page-quanto-calcolatore":"page-quanto-calcolatore","page-quanto-manifesto":"page-quanto-manifesto","page-quanto-pacchetti":"page-quanto-pacchetti","page-quanto-pacchetti-confrontaConti-packageId":"page-quanto-pacchetti-confrontaConti-packageId","page-quanto-vincoli":"page-quanto-vincoli","page-stories":"page-stories","page-tuttorial":"page-tuttorial"}[chunkId]||chunkId) + "." + {"chunk-0d54a9ea":"5a40f606","page-carte-e-servizi":"44ebb0a5","page-carte-e-servizi-carte":"e73badfb","page-carte-e-servizi-carte-creditclassic":"e18c25a8","page-carte-e-servizi-carte-creditprestige":"0631d1c9","page-carte-e-servizi-carte-internazionale":"c6fb270c","page-carte-e-servizi-carte-panoramica":"a1ef7912","page-carte-e-servizi-carte-prepagata":"151fb490","page-carte-e-servizi-internetBanking":"825570c4","page-carte-e-servizi-tecnologia":"be0ac522","page-carte-e-servizi-tecnologia-applePay":"49c00dfa","page-carte-e-servizi-tecnologia-bancomatPay":"b2e80c36","page-carte-e-servizi-tecnologia-bancomatPay-dettagli":"b8818f5e","page-carte-e-servizi-tecnologia-digitalPayments":"59289a19","page-carte-e-servizi-tecnologia-mobilePayments":"48a862f9","page-carte-e-servizi-tecnologia-plick":"7811004b","page-footer":"616b5fb5","page-footer-numeriUtili":"a3a071c7","page-footer-privacy":"85a7446d","page-footer-sicurezza":"f2f7ada3","page-footer-trasparenza":"e8f24881","page-help":"ea154683","page-index":"41f0a752","page-insiemeperlambiente":"1319cf08","page-insiemeperlambiente-ilnostroimpegno":"bd28f105","page-insiemeperlambiente-mediterraneo":"21757721","page-insiemeperlambiente-plasticFreeVideo":"12dc5d3d","page-partner":"074a354a","page-quanto":"eaa985c0","page-quanto-calcolatore":"23112280","page-quanto-manifesto":"cf23626a","page-quanto-pacchetti":"b0877912","page-quanto-pacchetti-confrontaConti-packageId":"c36fa69c","page-quanto-vincoli":"137bdfd3","page-stories":"13b685c3","page-tuttorial":"b8e4ea8b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0d54a9ea":1,"page-carte-e-servizi-tecnologia-bancomatPay-dettagli":1,"page-footer-sicurezza":1,"page-help":1,"page-insiemeperlambiente":1,"page-insiemeperlambiente-plasticFreeVideo":1,"page-quanto-calcolatore":1,"page-quanto-manifesto":1,"page-quanto-pacchetti":1,"page-quanto-pacchetti-confrontaConti-packageId":1,"page-stories":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"page-carte-e-servizi":"page-carte-e-servizi","page-carte-e-servizi-carte":"page-carte-e-servizi-carte","page-carte-e-servizi-carte-creditclassic":"page-carte-e-servizi-carte-creditclassic","page-carte-e-servizi-carte-creditprestige":"page-carte-e-servizi-carte-creditprestige","page-carte-e-servizi-carte-internazionale":"page-carte-e-servizi-carte-internazionale","page-carte-e-servizi-carte-panoramica":"page-carte-e-servizi-carte-panoramica","page-carte-e-servizi-carte-prepagata":"page-carte-e-servizi-carte-prepagata","page-carte-e-servizi-internetBanking":"page-carte-e-servizi-internetBanking","page-carte-e-servizi-tecnologia":"page-carte-e-servizi-tecnologia","page-carte-e-servizi-tecnologia-applePay":"page-carte-e-servizi-tecnologia-applePay","page-carte-e-servizi-tecnologia-bancomatPay":"page-carte-e-servizi-tecnologia-bancomatPay","page-carte-e-servizi-tecnologia-bancomatPay-dettagli":"page-carte-e-servizi-tecnologia-bancomatPay-dettagli","page-carte-e-servizi-tecnologia-digitalPayments":"page-carte-e-servizi-tecnologia-digitalPayments","page-carte-e-servizi-tecnologia-mobilePayments":"page-carte-e-servizi-tecnologia-mobilePayments","page-carte-e-servizi-tecnologia-plick":"page-carte-e-servizi-tecnologia-plick","page-footer":"page-footer","page-footer-numeriUtili":"page-footer-numeriUtili","page-footer-privacy":"page-footer-privacy","page-footer-sicurezza":"page-footer-sicurezza","page-footer-trasparenza":"page-footer-trasparenza","page-help":"page-help","page-index":"page-index","page-insiemeperlambiente":"page-insiemeperlambiente","page-insiemeperlambiente-ilnostroimpegno":"page-insiemeperlambiente-ilnostroimpegno","page-insiemeperlambiente-mediterraneo":"page-insiemeperlambiente-mediterraneo","page-insiemeperlambiente-plasticFreeVideo":"page-insiemeperlambiente-plasticFreeVideo","page-partner":"page-partner","page-quanto":"page-quanto","page-quanto-calcolatore":"page-quanto-calcolatore","page-quanto-manifesto":"page-quanto-manifesto","page-quanto-pacchetti":"page-quanto-pacchetti","page-quanto-pacchetti-confrontaConti-packageId":"page-quanto-pacchetti-confrontaConti-packageId","page-quanto-vincoli":"page-quanto-vincoli","page-stories":"page-stories","page-tuttorial":"page-tuttorial"}[chunkId]||chunkId) + "." + {"chunk-0d54a9ea":"0e4b1b58","page-carte-e-servizi":"31d6cfe0","page-carte-e-servizi-carte":"31d6cfe0","page-carte-e-servizi-carte-creditclassic":"31d6cfe0","page-carte-e-servizi-carte-creditprestige":"31d6cfe0","page-carte-e-servizi-carte-internazionale":"31d6cfe0","page-carte-e-servizi-carte-panoramica":"31d6cfe0","page-carte-e-servizi-carte-prepagata":"31d6cfe0","page-carte-e-servizi-internetBanking":"31d6cfe0","page-carte-e-servizi-tecnologia":"31d6cfe0","page-carte-e-servizi-tecnologia-applePay":"31d6cfe0","page-carte-e-servizi-tecnologia-bancomatPay":"31d6cfe0","page-carte-e-servizi-tecnologia-bancomatPay-dettagli":"b66c6364","page-carte-e-servizi-tecnologia-digitalPayments":"31d6cfe0","page-carte-e-servizi-tecnologia-mobilePayments":"31d6cfe0","page-carte-e-servizi-tecnologia-plick":"31d6cfe0","page-footer":"31d6cfe0","page-footer-numeriUtili":"31d6cfe0","page-footer-privacy":"31d6cfe0","page-footer-sicurezza":"24308810","page-footer-trasparenza":"31d6cfe0","page-help":"080c1f1f","page-index":"31d6cfe0","page-insiemeperlambiente":"e21653be","page-insiemeperlambiente-ilnostroimpegno":"31d6cfe0","page-insiemeperlambiente-mediterraneo":"31d6cfe0","page-insiemeperlambiente-plasticFreeVideo":"08329dbe","page-partner":"31d6cfe0","page-quanto":"31d6cfe0","page-quanto-calcolatore":"fbb1ec83","page-quanto-manifesto":"2813dca0","page-quanto-pacchetti":"04f000aa","page-quanto-pacchetti-confrontaConti-packageId":"190a621c","page-quanto-vincoli":"31d6cfe0","page-stories":"450d6f8a","page-tuttorial":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
